import {Routes} from '@angular/router';
import {CompanyList} from '@components/company/company-list/company-list';
import {Dashboard} from '@components/dashboard/dashboard';
import {CompanyWorkspace} from '@components/company/company-workspace/company-workspace';
import {CompanyEntreprise} from '@components/company/company-entreprise/company-entreprise';
import {CompanyWallet} from '@components/company/company-wallet/company-wallet';
import {CompanyAttestations} from '@components/company/company-attestations/company-attestations';
import {CompanyDossierFiscal} from '@components/company/company-dossier-fiscal/company-dossier-fiscal';
import {CompanyDocuments} from '@components/company/company-documents/company-documents';
import {CompanyCertifications} from '@components/company/company-certifications/company-certifications';
import {CompanyVeille} from '@components/company/company-veille/company-veille';
import {CompanySurveillance} from '@components/company/company-surveillance/company-surveillance';
import {CompanyAlertes} from '@components/company/company-alertes/company-alertes';
import {DashboardEntryRedirect} from '@components/dashboard/dashboard-entry-redirect/dashboard-entry-redirect';
import {CompanyKbis} from '@components/company/company-kbis/company-kbis';
import {CompanyRib} from '@components/company/company-rib/company-rib';
import {CompanyTransmettre} from '@components/company/company-transmettre/company-transmettre';
import {CompanyNotifications} from '@components/company/company-notifications/company-notifications';
import {CompanyParametres} from '@components/company/company-parametres/company-parametres';
import {CompanyDashboard} from '@components/company/company-dashboard/company-dashboard';
import {ExpertDashboard} from '@components/expert/expert-dashboard/expert-dashboard';
import {ExpertClients} from '@components/expert/expert-clients/expert-clients';
import {ExpertFiscalTracking} from '@components/expert/expert-fiscal-tracking/expert-fiscal-tracking';
import {ExpertPortal} from '@components/expert/expert-portal/expert-portal';
import {ExpertDocuments} from '@components/expert/expert-documents/expert-documents';
import {ExpertNotifications} from '@components/expert/expert-notifications/expert-notifications';
import {ExpertSettings} from '@components/expert/expert-settings/expert-settings';
import {ExpertPayment} from '@components/expert/expert-payment/expert-payment';
import {ExpertWalletQr} from '@components/expert/expert-wallet-qr/expert-wallet-qr';
import {expertPaymentGuard, expertPaymentPageGuard} from '../../guards/expert-payment.guard';
import {executiveSpaceGuard} from '../../guards/executive-space.guard';
import {adminGuard} from '../../guards/admin.guard';
import {AdminUsers} from '@components/admin/admin-users/admin-users';

export const ATTESTIO_DASHBOARD_ROUTE: Routes = [
  {path: '', component: DashboardEntryRedirect, pathMatch: 'full'},
  {
    path: '',
    component: Dashboard,
    children: [
      {
        path: 'overview',
        component: CompanyList,
        canActivate: [executiveSpaceGuard],
        data: {breadcrumb: 'Dashboard'},
      },
      {
        path: 'admin/users',
        component: AdminUsers,
        canActivate: [adminGuard],
        data: {breadcrumb: 'Utilisateurs'},
      },
      {
        path: 'overview/:siret',
        redirectTo: 'company/:siret/tableau-de-bord',
        pathMatch: 'full',
      },
      {
        path: 'company/:siret',
        component: CompanyWorkspace,
        canActivate: [executiveSpaceGuard],
        data: {breadcrumb: 'Entreprise'},
        children: [
          {path: '', redirectTo: 'tableau-de-bord', pathMatch: 'full'},
          {path: 'tableau-de-bord', component: CompanyDashboard},
          {path: 'entreprise', component: CompanyEntreprise},
          {path: 'wallet', component: CompanyWallet},
          {path: 'kbis', component: CompanyKbis},
          {path: 'rib', component: CompanyRib},
          {path: 'attestations', component: CompanyAttestations},
          {path: 'dossier-fiscal', component: CompanyDossierFiscal},
          {path: 'documents', component: CompanyDocuments},
          {path: 'certifications', component: CompanyCertifications},
          {path: 'transmettre', component: CompanyTransmettre},
          {path: 'veille-juridique', component: CompanyVeille},
          {path: 'surveillance', component: CompanySurveillance},
          {path: 'alertes', component: CompanyAlertes},
          {path: 'notifications', component: CompanyNotifications},
          {path: 'parametres', component: CompanyParametres},
        ],
      },
      {
        path: 'expert',
        data: {breadcrumb: 'Expert-comptable'},
        children: [
          {
            path: 'paiement',
            component: ExpertPayment,
            canActivate: [expertPaymentPageGuard],
            data: {breadcrumb: 'Paiement'},
          },
          {
            path: '',
            canActivate: [expertPaymentGuard],
            children: [
              {path: '', redirectTo: 'clients', pathMatch: 'full'},
              {path: 'tableau-de-bord', component: ExpertDashboard},
              {path: 'clients', component: ExpertClients},
              {path: 'suivi-fiscal', component: ExpertFiscalTracking},
              {path: 'portail-echange', component: ExpertPortal},
              {path: 'documents', component: ExpertDocuments},
              {path: 'notifications', component: ExpertNotifications},
              {path: 'wallet-qr', component: ExpertWalletQr, data: {breadcrumb: 'QR Wallet'}},
              {path: 'parametres', component: ExpertSettings},
            ],
          },
        ],
      },
    ],
  },
];
